import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { VideoComponent } from "@hermes/aphrodite/video";
import { ImageResizerModule } from "@hermes/fragments/image-resizer";

import { StoryBehindEditoComponent } from "./story-behind-edito/story-behind-edito.component";
import { StoryBehindComponent } from "./story-behind.component";

@NgModule({
    imports: [CommonModule, VideoComponent, ImageResizerModule],
    declarations: [StoryBehindComponent, StoryBehindEditoComponent],
    exports: [StoryBehindComponent, StoryBehindEditoComponent],
})
export class StoryBehindModule {}
